// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1JiuG","radioRow":"SimpleQuestionBuilderModal_radioRow__2MRAE"};